import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const DashboardLayout = ({ children, noPadding = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar-collapsed');
    return saved === 'true';
  });

  const handleToggleCollapse = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebar-collapsed', String(next));
      return next;
    });
  };

  return (
    <div className="dashboard-viewport flex min-h-0 overflow-hidden bg-[#f7f7f8] font-sans">
      {/* Sidebar with collapsed state */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />

      {/* Main content inset panel */}
      <div className="my-0 mx-0 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-white relative z-10 transition-all duration-300 sm:my-1 sm:mx-1 sm:rounded-2xl sm:border sm:border-zinc-200/80 sm:shadow-sm">
        <Topbar
          onMenuClick={() => setSidebarOpen(true)}
          isCollapsed={isCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />

        <main
          className={`min-h-0 flex-1 overflow-y-auto overflow-x-hidden bg-white ${
            noPadding ? '' : 'p-3 sm:p-4 md:p-5'
          }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
